import { AllergyIntolerance, MedicationStatement } from "@curai/js-fhir-tools";
import { z } from "zod";

export const updateMedicationFormSchema = z
  .object({
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    notes: z.string().optional(),
  })
  .superRefine((args, ctx) => {
    if (args.startDate && args.endDate && args.startDate > args.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        fatal: true,
        message: "End date must be after start date",
      });
    }
  });

export const createMedicationFormSchema = z
  .object({
    medicationCode: z.string().min(1, "A non-freetext medication is required."),
    medicationName: z.string(),
    medicationCodeSystem: z.string(),
    status: z
      .enum(
        Object.values(MedicationStatement.Status.values) as [
          string,
          ...string[],
        ],
      )
      .optional(),
    startDate: z.date().optional(),
    endDate: z.date().optional(),
    notes: z.string().optional(),
  })
  .superRefine((args, ctx) => {
    if (args.startDate && args.endDate && args.startDate > args.endDate) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["endDate"],
        fatal: true,
        message: "End date must be after start date",
      });
    }
  });

const reactionItemSchema = z.object({
  id: z.string().optional(),
  severity: z.string().optional(),
  description: z.string().optional(),
});

export const updateAllergyFormSchema = z.object({
  allergyType: z.enum([
    AllergyIntolerance.AllergyIntoleranceType.ALLERGY,
    AllergyIntolerance.AllergyIntoleranceType.INTOLERANCE,
  ]),
  notes: z.string().optional(),
  reactions: z.array(reactionItemSchema).optional(),
});

export const createAllergyFormSchema = z.object({
  allergyCode: z.string().min(1, "A non-freetext allergy is required."),
  allergyName: z.string(),
  allergyCodeSystem: z.string(),
  allergyType: z.enum([
    AllergyIntolerance.AllergyIntoleranceType.ALLERGY,
    AllergyIntolerance.AllergyIntoleranceType.INTOLERANCE,
  ]),
  notes: z.string().optional(),
  reactions: z.array(reactionItemSchema).optional(),
});

export const createMultipleMedicationsFormSchema = z.object({
  medications: z
    .array(
      z.object({
        code: z.string(),
        display: z.string(),
        system: z.string(),
      }),
    )
    .min(1, "At least one medication must be selected."),
});
